// extracted by mini-css-extract-plugin
module.exports = {"recaptchaMessage":"styles_recaptchaMessage__icwCy","paymentForm":"styles_paymentForm__e-sK2","secureIcon":"styles_secureIcon__2-Q9Y"};